import React, { useEffect, useState } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../../_metronic/_partials/controls";
import Table, {
  dateFormatter,
  buttonsStyle,
} from "../../../components/tables/table";
import ConfirmDialog from "../../../components/dialogs/ConfirmDialog";
import {
  getContacts,
  deleteContact,
  changeStatusContact,
} from "../../../../api/contact";
import {
  Button,
  Tooltip,
  Switch,
  FormControlLabel,
  TextField,
  Chip,
  MenuItem,
} from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";
import AddIcon from "@material-ui/icons/Add";
import { Autorenew as FilterOffIcon } from "@material-ui/icons";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import { alertError, alertSuccess } from "../../../../utils/logger";
import { useHistory } from "react-router-dom";
import ToggleOffIcon from "@material-ui/icons/ToggleOff";
import ToggleOnIcon from "@material-ui/icons/ToggleOn";
import { shallowEqual, useSelector } from "react-redux";
import {
  canEditGestionModule,
  isReadOnlyConsultor,
} from "../../../../_helpers/backofficePermissions";
import FiltersCard from "../../../components/filters/Filter";
import { cleanHtmlAndTruncate } from "../../../../utils/helpers";

const CONTACT_TIPO_OPTIONS = [
  { value: "", label: "Todos los tipos" },
  { value: "general", label: "Web general" },
  { value: "web_congresos", label: "Contacto congreso" },
  { value: "web_congresos_patrocinio", label: "Patrocinio" },
  { value: "web_congresos_envio_trabajo", label: "Envío trabajo" },
];

function contactTipoCategoria(origenFormulario) {
  const o = String(origenFormulario || "").trim();
  if (!o) return "general";
  return o;
}

function contactTipoLabel(origenFormulario) {
  const cat = contactTipoCategoria(origenFormulario);
  const opt = CONTACT_TIPO_OPTIONS.find((o) => o.value === cat);
  return opt ? opt.label : "Web general";
}

function getData(contacts) {
  let data = [];
  for (let i = 0; i < contacts.length; ++i) {
    const c = contacts[i];
    const elem = {};
    elem.name = c.name;
    elem.email = c.email;
    elem.tel = c.tel;
    elem.fechaRes = c.fechaRes;
    elem.mensaje = c.mensaje;
    elem.id = c._id;
    elem._id = c._id;
    elem.gestionado = c.gestionado;
    elem.asunto = c.asunto;
    elem.active = c.active;
    elem.createdAt = c.createdAt;
    elem.origenFormulario = c.origenFormulario;
    elem.congresoEdicionYear = c.congresoEdicionYear;
    elem.tipoCategoria = contactTipoCategoria(c.origenFormulario);
    elem.esPatrocinio = c.origenFormulario === "web_congresos_patrocinio";
    elem.esCongreso = c.origenFormulario === "web_congresos";
    elem.esEnvioTrabajo = c.origenFormulario === "web_congresos_envio_trabajo";
    elem.tipoLabel = contactTipoLabel(c.origenFormulario);
    data = data.concat(elem);
  }
  return data;
}

const initialFilters = {
  active: false,
  tipo: "",
};

function applyContactFilters(items, filterOptions) {
  return items.filter((item) => {
    let ok = true;
    if (filterOptions.active) ok = ok && item.active;
    if (filterOptions.tipo) {
      ok = ok && contactTipoCategoria(item.origenFormulario) === filterOptions.tipo;
    }
    return ok;
  });
}

export default function ContactsPage() {
  const [data, setData] = useState([]);
  const [contactId, setContactId] = useState(null);
  const [openConfirmDialog, setOpenConfirmDialog] = useState(null);
  const [refresh, setRefresh] = useState(false);
  const [filteredData, setFilteredData] = useState([]);
  const [collapsed, setCollapsed] = useState(true);
  // Cargar filtros desde localStorage al iniciar
  const [filterOptions, setFilterOptions] = useState(() => {
    const savedFilters = localStorage.getItem('contactsPageFilters');
    return savedFilters ? JSON.parse(savedFilters) : initialFilters;
  });
  // Estado para el campo de búsqueda
  const [searchText, setSearchText] = useState(() => {
    const saved = localStorage.getItem('contactsPage_searchText');
    return saved || '';
  });
  const history = useHistory();
  const user = useSelector((store) => store.authentication?.user, shallowEqual);

  function buttonFormatter(cell) {
    const elem = data.find((item) => String(item._id) === String(cell));
    return (
      <>
        <Tooltip title="Edit">
          <Button
            style={buttonsStyle}
            size="small"
            onClick={() => {
              // Guardar filtros actuales antes de navegar
              localStorage.setItem('contactsPageFilters', JSON.stringify(filterOptions));
              history.push("/edit-contact/" + cell);
            }}
          >
            <EditIcon />
          </Button>
        </Tooltip>
        {(canEditGestionModule(user?.role) && !isReadOnlyConsultor(user?.role)) && (
          <>
            <Tooltip title={elem?.active ? "Disable" : "Enable"}>
              <Button
                style={buttonsStyle}
                size="small"
                onClick={() => {
                  setContactId(elem);
                  setOpenConfirmDialog(1);
                }}
              >
                {elem?.active ? (
                  <ToggleOffIcon />
                ) : (
                  <ToggleOnIcon style={{ color: "red" }} />
                )}
              </Button>
            </Tooltip>
            <Tooltip title="Delete">
              <Button
                style={buttonsStyle}
                size="small"
                onClick={() => {
                  setContactId(cell);
                  setOpenConfirmDialog(2);
                }}
              >
                <DeleteIcon />
              </Button>
            </Tooltip>
          </>
        )}
      </>
    );
  }

  const columns = [
    {
      dataField: "tipoLabel",
      text: "Tipo",
      sort: true,
      formatter: (_cell, row) => {
        const chipStyle = {
          fontWeight: 700,
          maxWidth: "100%",
          height: "auto",
          whiteSpace: "normal",
          wordBreak: "break-word",
        };
        if (row.esEnvioTrabajo) {
          return (
            <Chip
              size="small"
              label={row.tipoLabel}
              title={row.tipoLabel}
              style={{ ...chipStyle, backgroundColor: "#dcfce7", color: "#14532d" }}
            />
          );
        }
        if (row.esPatrocinio) {
          return (
            <Chip
              size="small"
              label={row.tipoLabel}
              title={row.tipoLabel}
              style={{ ...chipStyle, backgroundColor: "#dbeafe", color: "#1e3a8a" }}
            />
          );
        }
        if (row.esCongreso) {
          return (
            <Chip
              size="small"
              label={row.tipoLabel}
              title={row.tipoLabel}
              style={{ ...chipStyle, backgroundColor: "#ffedd5", color: "#9a3412" }}
            />
          );
        }
        return <Chip size="small" label="Web general" variant="outlined" />;
      },
    },
    { dataField: "asunto", text: "Asunto", sort: true },
    { dataField: "email", text: "Email", sort: true },
    { dataField: "tel", text: "Teléfono", sort: true },
    {
      dataField: "mensaje",
      text: "Mensaje",
      sort: true,
      formatter: (cell) => {
        return cleanHtmlAndTruncate(cell);
      },
    },
    { dataField: "gestionado", text: "Estado", sort: true },
    {
      dataField: "createdAt",
      text: "Fecha alta",
      sort: true,
      formatter: dateFormatter,
    },
    { dataField: "id", text: "", formatter: buttonFormatter },
  ];

  useEffect(() => {
    const fetchData = async () => {
      try {
        getContacts()
          .then((res) => {
            if (res.status === 200) {
              setData(res.data);
              // Aplicar filtros guardados si existen
              const savedFilters = localStorage.getItem('contactsPageFilters');
              if (savedFilters) {
                const savedFilterOptions = JSON.parse(savedFilters);
                setFilterOptions(savedFilterOptions);
                // Aplicar filtros automáticamente
                setFilteredData(applyContactFilters(res.data, savedFilterOptions));
              } else {
                setFilteredData(res.data);
              }
              setRefresh(false);
            }
          })
          .catch((error) => {
            alertError({
              error: error,
              customMessage: "Could not get contacts.",
            });
          });
      } catch (error) {}
    };

    fetchData();
  }, [refresh]);

  const handleSearch = async () => {
    if (!data.length) return;
    // Guardar filtros en localStorage
    localStorage.setItem('contactsPageFilters', JSON.stringify(filterOptions));
    setFilteredData(applyContactFilters(data, filterOptions));
  };

  const handleClearFilters = () => {
    setFilterOptions(initialFilters);
    setSearchText('');
    localStorage.removeItem('contactsPageFilters');
    localStorage.removeItem('contactsPage_searchText');
    localStorage.removeItem('contactsPage_currentPage');
    setRefresh(true);
  };

  const renderFiltersContent = () => {
    return (
      <div style={{ padding: "15px 0 0 0" }}>
        {/* Primera fila: Campo de búsqueda */}
        <div className="row align-items-end">
          <div className="col-md-3 col-sm-6 mb-3">
            <TextField
              id="contact-filter-tipo"
              select
              label="Tipo"
              value={filterOptions.tipo || ""}
              onChange={(e) =>
                setFilterOptions({
                  ...filterOptions,
                  tipo: e.target.value,
                })
              }
              margin="dense"
              variant="outlined"
              fullWidth
              style={{ marginTop: 0, marginBottom: 0 }}
            >
              {CONTACT_TIPO_OPTIONS.map((opt) => (
                <MenuItem key={opt.value || "all"} value={opt.value}>
                  {opt.label}
                </MenuItem>
              ))}
            </TextField>
          </div>
          <div className="col-md-3 col-sm-6 mb-3">
            <TextField
              id="search"
              label="Buscar"
              placeholder="Buscar en todos los campos..."
              value={searchText}
              onChange={(e) => {
                const value = e.target.value;
                setSearchText(value);
                if (value.trim()) {
                  localStorage.setItem('contactsPage_searchText', value);
                } else {
                  localStorage.removeItem('contactsPage_searchText');
                }
              }}
              margin="dense"
              variant="outlined"
              fullWidth
              style={{ marginTop: 0, marginBottom: 0 }}
            />
          </div>
        </div>
        {/* Switches y botones de acción en la misma línea */}
        <div className="row">
          <div className="col-12">
            <div className="d-flex justify-content-between align-items-center flex-wrap" style={{ marginTop: "10px", marginBottom: "10px", gap: "15px" }}>
              {/* Switches a la izquierda */}
              <div className="d-flex align-items-center flex-wrap" style={{ gap: "30px" }}>
                <FormControlLabel
                  control={
                    <Switch
                      checked={filterOptions.active}
                      onChange={() =>
                        setFilterOptions({
                          ...filterOptions,
                          active: !filterOptions.active,
                        })
                      }
                      name="checkActive"
                      style={{ color: "#f3691a" }}
                    />
                  }
                  label={filterOptions.active ? "Solo activos" : "Todos (activos/inactivos)"}
                  style={{ margin: 0 }}
                />
              </div>
              {/* Botones a la derecha */}
              <div className="d-flex">
                <Button
                  variant="contained"
                  onClick={handleSearch}
                  startIcon={<SearchIcon />}
                  style={{ 
                    minWidth: "120px",
                    backgroundColor: "#f3691a",
                    color: "#fff",
                    marginRight: "10px"
                  }}
                >
                  Buscar
                </Button>
                <Button
                  variant="outlined"
                  onClick={handleClearFilters}
                  startIcon={<FilterOffIcon />}
                  style={{ 
                    minWidth: "120px",
                    borderColor: "#f3691a",
                    color: "#f3691a"
                  }}
                >
                  Limpiar
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      <Card>
        <CardHeader title="Lista Contacts">
          <CardHeaderToolbar>
            <Button
              variant="contained"
              onClick={() => history.push("/edit-contact")}
              startIcon={<AddIcon />}
              style={{
                backgroundColor: "#f3691a",
                color: "#fff",
              }}
            >
              Añadir nuevo
            </Button>
          </CardHeaderToolbar>
        </CardHeader>
        <CardBody style={{ paddingTop: "15px" }}>
          {/* Filtros siempre visibles con mejor diseño */}
          <Card style={{ marginBottom: "15px", backgroundColor: "#f8f9fa" }}>
            <CardBody style={{ padding: "15px 20px" }}>
              {renderFiltersContent()}
            </CardBody>
          </Card>

          <Table 
            data={getData(filteredData)} 
            columns={columns} 
            pageKey="contactsPage"
            searchText={searchText}
            onSearchChange={(value) => {
              setSearchText(value);
              if (value.trim()) {
                localStorage.setItem('contactsPage_searchText', value);
              } else {
                localStorage.removeItem('contactsPage_searchText');
              }
            }}
            defaultSorted={[{ dataField: 'createdAt', order: 'desc' }]}
          />

          <ConfirmDialog
            title={`Are you sure you want to ${
              contactId?.active ? "disable" : "enable"
            } this user type?`}
            open={openConfirmDialog === 1}
            setOpen={setOpenConfirmDialog}
            onConfirm={() => {
              changeStatusContact(contactId._id || contactId.id, !contactId?.active)
                .then((res) => {
                  if (res.status === 200) {
                    alertSuccess({
                      title: `${contactId?.active ? "Disabled!" : "Enabled!"}`,
                      customMessage: `User type ${
                        contactId?.active ? "disabled" : "enabled"
                      } successfully`,
                    });
                    setRefresh(true);
                  }
                })
                .catch((error) => {
                  alertError({
                    error: error,
                    customMessage: `Could not ${
                      contactId?.active ? "disable" : "enable"
                    } user type.`,
                  });
                });
            }}
          />
          <ConfirmDialog
            title={"Are you sure you want to remove this user type?"}
            open={openConfirmDialog === 2}
            setOpen={setOpenConfirmDialog}
            onConfirm={() => {
              deleteContact(contactId)
                .then((res) => {
                  if (res.status === 204 || res.status === 200) {
                    alertSuccess({
                      title: "Deleted!",
                      customMessage: "Contact removed successfully.",
                    });
                    setRefresh(true);
                  }
                })
                .catch((error) => {
                  alertError({
                    error: error,
                    customMessage: "Could not remove contact.",
                  });
                });
            }}
          />
        </CardBody>
      </Card>
    </>
  );
}
